export default __webpack_public_path__ + "static/media/btn-store-bottom.56276be5.svg";